import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import PrivateRoute from './components/PrivateRoute/PrivateRoute';

import routes from "./routes";

import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./assets/global.css";

export default () => {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <div>
        {routes.map((route, index) => {
          if (route.private) {
            return (
              <PrivateRoute
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
                layout={route.layout}
              />
            );
          } else {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
                layout={route.layout}
              />
            );
          }
        })}
      </div>
    </Router>
  )
};
